import o from"lodash/compact";function t({line1:t,city:e,region:i,postal:n},r=" "){return o([t,e,i.code,n]).join(r)}export{t as default};
//# sourceMappingURL=getAddressString.js.map
